import React from "react";
import { ContentGrid, Grid2, SectionBox } from "../styles";
import { Card, Button, Pill, ProgressRing } from "../components";

const SessionsView = ({ sessions, setSessions, overallRisk, twoFA, emailOtp, riskTier, pushToast, uid, setAudit, otpOpen, setOtpOpen, otpCode, setOtpCode, otpSentAt, setOtpSentAt }) => {
  const riskLabel = (v) => {
    if (v >= 75) return { t: "High", tone: "b" };
    if (v >= 45) return { t: "Med", tone: "c" };
    return { t: "Low", tone: "d" };
  };

  return (
    <ContentGrid>
      <Card title="Sessions & Geo-IP" icon="map" right={<Pill tone="d">Timeline • Risk per device</Pill>}>
        <ContentGrid>
          <Grid2>
            <SectionBox>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, marginBottom: 10 }}>
                <div style={{ fontWeight: 900 }}>Geo Map (placeholder)</div>
                <Pill>Mapbox-ready</Pill>
              </div>
              <div style={{ height: 220, borderRadius: 14, border: "1px dashed rgba(92,233,255,.22)", background: "radial-gradient(circle at 25% 25%, rgba(92,233,255,.16), transparent 60%), radial-gradient(circle at 65% 55%, rgba(0,247,210,.12), transparent 60%), rgba(255,255,255,.03)", display: "grid", placeItems: "center", color: "rgba(210,235,245,.75)", textAlign: "center", padding: 10 }}>
                <ContentGrid>
                  <div style={{ fontWeight: 900, color: "rgba(240,250,255,.9)" }}>Custodiy Geo-IP Layer</div>
                  <div style={{ fontSize: 12 }}>Pins + heat + session timeline • plug your Mapbox token</div>
                </ContentGrid>
              </div>
            </SectionBox>

            <SectionBox>
              <div style={{ fontWeight: 900 }}>Risk Engine</div>
              <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                <ProgressRing value={overallRisk} />
                <ContentGrid>
                  <div style={{ fontWeight: 900 }}>Overall posture</div>
                  <div style={{ fontSize: 12, color: "rgba(210,235,245,.72)" }}>Derived from sessions + compliance tier</div>
                </ContentGrid>
              </div>
              <ContentGrid>
                <Pill tone="d">2FA impact: {twoFA ? "-10" : "+10"}</Pill>
                <Pill tone="c">Email OTP impact: {emailOtp ? "+6" : "+14"}</Pill>
                <Pill tone="b">Compliance tier: {riskTier.replace("_", " ")}</Pill>
              </ContentGrid>
            </SectionBox>
          </Grid2>

          <SectionBox>
            <div style={{ padding: 12, borderBottom: "1px solid rgba(92,233,255,.10)", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
              <div style={{ fontWeight: 900 }}>Active Sessions</div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                <Button
                  variant="sec"
                  onClick={() => {
                    setOtpSentAt(Date.now());
                    setOtpCode("");
                    setOtpOpen(true);
                    pushToast("Sessions", "Verification required (demo)");
                  }}
                >
                  Step-up
                </Button>
                <Button
                  variant="danger"
                  onClick={() => {
                    setSessions((s) => s.map((x) => (x.status === "active" ? { ...x, status: "expired", lastSeen: "Just revoked" } : x)));
                    pushToast("Sessions", "All active sessions revoked");
                    setAudit((s) => [{ id: uid(), ts: "2026-01-08 08:53", actor: "user", type: "Sessions", detail: "Revoke all sessions", severity: "med" }, ...s]);
                  }}
                >
                  Revoke all
                </Button>
              </div>
            </div>
            <ContentGrid>
              {sessions.map((s) => {
                const r = riskLabel(s.risk);
                return (
                  <Grid2 key={s.id} style={{ padding: 12, borderRadius: 14, border: "1px solid rgba(92,233,255,.12)", background: "rgba(255,255,255,.03)" }}>
                    <ContentGrid>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
                        <div style={{ fontWeight: 900 }}>{s.device}</div>
                        <Pill tone={r.tone}>{r.t + " • " + s.risk}</Pill>
                      </div>
                      <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)" }}>{s.city + ", " + s.country + " • " + s.ip + " • " + s.lastSeen}</div>
                      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                        {s.status === "active" ? <Pill tone="d">Active</Pill> : <Pill tone="b">Expired</Pill>}
                        {s.risk >= 60 ? <Pill tone="b">Anomaly</Pill> : <Pill tone="a">Normal</Pill>}
                      </div>
                    </ContentGrid>
                    <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", alignItems: "center", flexWrap: "wrap" }}>
                      <Button variant="sec" onClick={() => pushToast("Audit", "Session detail opened (demo)")}>Details</Button>
                      <Button
                        variant={s.status === "active" ? "danger" : "ghost"}
                        disabled={s.status !== "active"}
                        onClick={() => {
                          setSessions((prev) => prev.map((x) => (x.id === s.id ? { ...x, status: "expired", lastSeen: "Just revoked" } : x)));
                          pushToast("Sessions", "Session revoked");
                          setAudit((p) => [{ id: uid(), ts: "2026-01-08 08:54", actor: "user", type: "Sessions", detail: "Revoked session " + s.device, severity: "med" }, ...p]);
                        }}
                        icon="logout"
                      >
                        Revoke
                      </Button>
                    </div>
                  </Grid2>
                );
              })}
            </ContentGrid>
          </SectionBox>
        </ContentGrid>
      </Card>
    </ContentGrid>
  );
};

export default SessionsView;
